import {getMorphoService, serviceNames} from '@/rte/editor';

const getEditor = () => {
    const editorStateService = getMorphoService(serviceNames.IEditorStateService);
    if (!editorStateService) {
        return null;
    }
    const editor = editorStateService.editor;
    if (!editor) {
        return null;
    }
    return editor;
};

export {getEditor};
